import React from "react";

const Folder = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M1 8h22v15H1zM21 4h-8l-2-3H3v3" />
    </g>
  </svg>
);

export default Folder;



// WEBPACK FOOTER //
// ./src/theme/icons/Folder.js